<template>
  <transition name="projet" @enter="enter" v-on:leave="leave" appear>
    <div>
      <div class="transition-block white"></div>
      <div class="transition-block black"></div>
      <article class="global parallax">
        <div class="top-container">
          <div class="image-container">
            <img
              ref="imageTop"
              class="image-top"
              src="../../../static/images/projets/asso-lard.jpg"
              alt="Image de Sachassou"
            />
          </div>
          <div class="title-projet-container">
            <h3>L.A.R.D.</h3>
          </div>
          <div class="scroll-down">
            <button class="iconbutton">
              <div class="scroll">
                <div class="scroll__wheel"></div>
              </div>
            </button>
          </div>
        </div>

        <div class="project-content" style="height: 200vh; ">
          <div class="presentation">
            <div class="type-projet splited">
              <h4>PROJET</h4>
              <ul>
                <li>Identité visuelle - proposition de logo | Adobe Illustrator</li>
                <li>Dossier | Adobe InDesign</li>
                <li>Maquettes graphiques | Adobe XD</li>
              </ul>
            </div>
            <div class="annee-projet splited">
              <h4>DATE</h4>2019
            </div>
          </div>
          <div class="description">
            <h4>DESCRIPTION</h4>
            <p>
              Le travail le plus important que j’ai réalisé au niveau du  graphisme au semestre 2 
              concernait la refonte graphique d’une association. Cette association regroupant 
              les Laboratoires Associés de Radiophysique et de Dosimétrie (L.A.R.D.) souhaitait 
              refondre son identité visuelle.
              Cette association regroupe des laboratoires de recherche français spécialisés en 
              radiophysique et en dosimétrie des rayonnements ionisants. Ces laboratoires dépendent 
              des Universités et des grands organismes de recherche et allient recherche fondamentale 
              et applications. <br><br>
              Éléments abordés :
              <ul>
                <li> Conception et réalisation d’un nouveau logo (sur Illustrator)</li>
                <li> Réalisation d’une charte graphique</li>
                <li> Réalisation d’une plaquette de présentation de l’association</li>
                <li> Réalisation d’une maquette pour la page d’accueil du site web</li>
              </ul>
              Voici un extrait de la charte graphique réalisée sur InDesign dans laquelle on peut voir le 
              logo proposé ainsi que ses différentes déclinaisons, des mockups de présentation et un aperçu 
              de la maquette graphique construite sur Adobe XD.
            </p>
            <div class="content-image-projet">
              <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-001.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
                style="width :50%; display: block; margin: 0 auto 30px auto;"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-002.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-003.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-004.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-005.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-006.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-007.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-008.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-009.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-010.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-011.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/charte-graphique-sans-parametres-page-012.jpg"
                alt="Extrait du dossier de refonte graphique des LARD"
                  style="width :50%; display: block; margin: 0 auto 30px auto;"
              />
            </div>
            <h4>PLAQUETTE</h4>
            <p>
              Une plaquette de présentation de la nouvelle identité visuelle a également été élaboré sur InDesign.
            </p>
            <div class="content-image-projet">
              <img
                class="img-w-bg"
                src="../../../static/images/LARD/trifol01-jpeg.png"
                alt="Extrait du dossier de refonte graphique des LARD"
                style="width :70%; display: block; margin: 0 auto 30px auto;"
              />
               <img
                class="img-w-bg"
                src="../../../static/images/LARD/trifol02-jpeg.png"
                alt="Extrait du dossier de refonte graphique des LARD"
                    style="width :70%; display: block; margin: 0 auto 30px auto;"
              />
            </div>
          </div>
          <div class="projet-suivant">
            <span>PROJET SUIVANT</span>
            <router-link to="/sachassou">
              <div class="next-container" ref="nextContainer">
                <div
                  @mouseenter="nextFxEnter"
                  @mouseleave="nextFxLeave"
                  @click="nextFxLeave"
                  ref="btnNext"
                  class="projet-suivant-content"
                >SACHASSOU</div>

                <svg class="arrow-cursor-bottom__icon" ref="arrowCursorIcon" viewBox="0 0 117.25 86.75">
                  <path
                    class="arrow-cursor-bottom__path"
                    ref="arrowCursorPath"
                    d="M111.45,42.5,74.65,5.7l-9.9,9.9,20.6,20.6H6.45v14h78.9L64.75,70.8l9.9,9.9,36.8-36.8A1,1,0,0,0,111.45,42.5Z"
                  />
                </svg>
              </div>
            </router-link>
          </div>
        </div>
      </article>
    </div>
  </transition>
</template>

<script>
//import Nearby from "../../script/nearby";
export default {
  name: "Sachassou",
  data() {
    return {};
  },
  methods: {
    enter(el, done) {
      var imageTop = el.querySelector(".top-container .image-container");

      TweenMax.set(imageTop, {
        opacity: 0
      });
      TweenMax.to(imageTop, 1, {
        delay: 1.4,
        opacity: 1,
        ease: Power4.easeOut
      });
      var image = el.querySelector(".top-container img");
      TweenMax.set(image, {
        filter: "brightness(50%)"
      });
      TweenMax.to(image, 1, {
        delay: 2,
        filter: "brightness(50%)",
        ease: Power4.easeOut
      });

      var title = el.querySelector(".title-projet-container h3");
      TweenMax.set(title, {
        //scale: 200
        y: "100%"
      });
      TweenMax.to(title, 0.8, {
        delay: 2,
        //scale: 1,
        y: 0,
        ease: Power4.easeOut,
        onComplete: done
      });
      var scroll = el.querySelector(".iconbutton");
      TweenMax.set(scroll, {
        y: "120%"
      });
      TweenMax.to(scroll, 0.8, {
        delay: 3,
        y: 0,
        ease: Power4.easeOut
      });
    },
    leave(el, done) {
        var blockWhite = el.querySelector(".transition-block.white");
      var blockBlack = el.querySelector(".transition-block.black");
       TweenMax.to(blockWhite, 0.8, {
        height: '100vh',
        ease: Power4.easeOut,
        
      });
      TweenMax.to(blockBlack, 0.8, {
        delay: 0.4,
        height: '100vh',
        ease: Power4.easeOut,
        onComplete: done
      });
    },
    scrollButtonEffect() {
      const distanceThreshold = { min: 0, max: 100 };
      const iconWrapperScroll = document.querySelector(".scroll");
      const iconScrollButton = iconWrapperScroll.parentNode;
      const scrollWheel = iconWrapperScroll.querySelector(".scroll__wheel");

      const scrollInterval = { from: 1, to: 15 };

      TweenMax.to(scrollWheel, 1, {
        repeat: -1,
        yoyo: false,
        y: 32,
        scaleY: 0
      });
    },
    nextFxEnter() {
      var btnNext = this.$refs.btnNext;
      var nextContainer = this.$refs.nextContainer;
      var arrowCursorIcon = this.$refs.arrowCursorIcon;
      var arrowCursorPath = this.$refs.arrowCursorPath;

      TweenMax.to(btnNext, 0.5, {
        color: "#ea5242"
      });
      TweenMax.to(nextContainer, 0.5, {
        x: "-4vw",
        ease: "back.out(1.7)"
      });
      TweenMax.to(arrowCursorIcon, 0.5, {
        x: "6vw",
        ease: "back.out(1.7)"
      });
      var cursorCircle = document.querySelector(".cursor__inner--circle");

      cursorCircle.classList.add("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 60 + "px",
        height: 60 + "px",
        top: -20 + "px",
        left: -20 + "px",
        ease: "back.out(1.7)"
      });
    },
    nextFxLeave() {
      var btnNext = this.$refs.btnNext;
      var nextContainer = this.$refs.nextContainer;
      var arrowCursorIcon = this.$refs.arrowCursorIcon;
      var arrowCursorPath = this.$refs.arrowCursorPath;
      TweenMax.to(btnNext, 0.5, {
        color: "#fff"
      });
      TweenMax.to(nextContainer, 0.5, {
        x: 0,
        ease: "back.out(1.7)"
      });
      TweenMax.to(arrowCursorIcon, 0.5, {
        x: 0,
        ease: "back.out(1.7)"
      });
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.remove("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 20,
        height: 20,
        top: 0,
        left: 0,
        ease: "back.out(1.7)"
      });
    },
    onLinkMouseEnter() {
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.add("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 60 + "px",
        height: 60 + "px",
        top: -20 + "px",
        left: -20 + "px",
        ease: "back.out(1.7)"
      });
    },
    onLinkMouseLeave() {
      var cursorCircle = document.querySelector(".cursor__inner--circle");
      cursorCircle.classList.remove("cursor-animate");
      TweenMax.to(cursorCircle, 0.3, {
        width: 20,
        height: 20,
        top: 0,
        left: 0,
        ease: "back.out(1.7)"
      });
    }
  },
  mounted() {
    this.scrollButtonEffect();
  }
};
</script>

<style scoped lang='scss'>
@import "../../assets/css/structure-projet.scss";
.description {
  ul {
    padding-left: 20px;
    li {
      padding-left: 10px;
      &::before {
         content: "\2022"; 
         color: #ea5242; 
         font-weight: bold; 
         display: inline-block; 
         width: 2em; 
         margin-left: -1em;
      }
    }
  } 
  .img-w-bg {
    margin-bottom: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/projets/AssoLard.vue